import { Component } from '@angular/core';

@Component({
    selector: 'xm-empty',
    template: ''
})
export class XmEmptyComponent {}
